import {RaisedButton, TextField, SelectField, MenuItem} from 'material-ui';
import FaAngleDoubleDown from 'react-icons/lib/fa/angle-double-down';
import FaAngleDoubleUp from 'react-icons/lib/fa/angle-double-up';
import FaTrash from 'react-icons/lib/fa/trash';
import PropTypes from 'prop-types';
import React from 'react';
import update from 'react-addons-update';

import {CONTENT_IMAGE, CONTENT_SINGLE_TEXT, CONTENT_TARGET, CONTENT_TEXT} from './contentConstants';
import {Centered1000} from '../Container';
import {HeadlineH2} from '../Text';
import {Label} from '../FormElements';
import ActionButtonRow from '../ActionButtonRow';
import ArkEdit from '../ArkEdit';
import BuilderItem, {RemoveBuilderItem, MoveBuilderItem} from './BuilderItem';
import FullScreenWrapper from '../FullscreenWrapper';
import MediaPicker from '../MediaPicker/MediaPicker';
import moveElementInArray from '../../utils/moveElementInArray';

export default class ChildsBuilder extends React.Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    inlineMode: PropTypes.bool.isRequired,
    itemConfig: PropTypes.array.isRequired,
    onApplyValues: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      values: props.values,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({values: nextProps.values});
  };

  _getEmptyItem = () => {
    const {itemConfig} = this.props;
    let emptyItem = {key: '' + Math.random()};
    itemConfig.forEach((configItem) => {
      emptyItem[configItem.key] = configItem.type === CONTENT_IMAGE ? null : '';
    });
    return emptyItem;
  };

  _addItem = () => {
    let values = [...this.state.values, this._getEmptyItem()];
    this.setState({values});
  };

  _removeItem = (idx) => {
    this.setState((prevState) => ({
      values: update(prevState.values, {$splice: [[idx, 1]]}),
    }));
  };
  _moveItem = (idx, change) => {
    const values = this.state.values;

    this.setState({
      values: moveElementInArray(values, idx, change),
    });
  };

  _updateValue = (idx, key, value) => {
    this.setState({values: update(this.state.values, {[idx]: {[key]: {$set: value}}})}, () => {
      if (this.props.inlineMode) {
        this.props.onApplyValues(this.state.values);
      }
    });
  };
  _setEdit = () => {
    this.setState({editMode: true});
  };
  _apply = () => {
    this.props.onApplyValues(this.state.values);
    this.setState({editMode: false});
  };

  _renderProp = (type, title, key, value, idx, config) => {
    if (type === CONTENT_SINGLE_TEXT) {
      return (
        <TextField
          floatingLabelText={title}
          fullWidth
          key={'textfield_' + key + idx}
          onChange={({target: {value}}) => this._updateValue(idx, key, value)}
          type='text'
          value={value}
        />
      );
    } else if (type === CONTENT_TEXT) {
      return (
        <div key={'arkedit_' + key + idx}>
          <Label>{title}</Label>
          <ArkEdit
            onChange={(value) => {
              this._updateValue(idx, key, value);
            }}
            value={value}
          />
        </div>
      );
    } else if (type === CONTENT_IMAGE) {
      return (
        <MediaPicker
          config={config}
          key={'media_' + key + idx}
          multiple={false}
          onSelect={(medias) => {
            let media = null;
            if (medias && medias.length > 0) {
              media = medias[0];
            }
            this._updateValue(idx, key, media);
          }}
          title={title}
          type={'image'}
          values={value ? [value] : []}
        />
      );
    } else if (type === CONTENT_TARGET) {
      return (
        <SelectField
          floatingLabelText='Target'
          key={'target_' + key + idx}
          onChange={(_, __, selectedValue) => {
            this._updateValue(idx, key, selectedValue);
          }}
          value={value}>
          <MenuItem key={'target1'} primaryText={'new window'} value={'_blank'} />
          <MenuItem key={'target2'} primaryText={'current window'} value={'_self'} />
        </SelectField>
      );
    }
  };

  _renderItem = (item, itemConfig, idx, config) => {
    return (
      <BuilderItem key={item.key}>
        {itemConfig.map((configItem) => {
          return this._renderProp(configItem.type, configItem.title, configItem.key, item[configItem.key], idx, config);
        })}
        <RemoveBuilderItem
          onClick={() => {
            this._removeItem(idx);
          }}>
          <FaTrash />
        </RemoveBuilderItem>
        <MoveBuilderItem
          onClick={() => {
            this._moveItem(idx, -1);
          }}
          up>
          <FaAngleDoubleUp />
        </MoveBuilderItem>
        <MoveBuilderItem
          onClick={() => {
            this._moveItem(idx, 1);
          }}>
          <FaAngleDoubleDown />
        </MoveBuilderItem>
      </BuilderItem>
    );
  };

  renderContent = (title, itemConfig, values, config, inlineMode) => {
    return (
      <div>
        <HeadlineH2>{title}</HeadlineH2>
        {values &&
          values.length !== 0 &&
          values.map((item, idx) => {
            return this._renderItem(item, itemConfig, idx, config);
          })}
        <ActionButtonRow>
          <RaisedButton label={'add'} onClick={this._addItem} />
          {!inlineMode && <RaisedButton label={'save'} onClick={this._apply} />}
        </ActionButtonRow>
      </div>
    );
  };

  render() {
    const {title, itemConfig, config, inlineMode} = this.props;
    const {values, editMode} = this.state;

    if (inlineMode) {
      return this.renderContent(title, itemConfig, values, config, inlineMode);
    }

    return (
      <div>
        <HeadlineH2>{title}</HeadlineH2>
        {!editMode && <RaisedButton label={'edit'} onClick={this._setEdit} />}
        {editMode && (
          <FullScreenWrapper>
            <Centered1000>{this.renderContent(title, itemConfig, values, config, inlineMode)}</Centered1000>
          </FullScreenWrapper>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/Content/ChildsBuilder.js